import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchQuoteRequestLineActivePrediction } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLineActivePrediction.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const quoteRequestLineActivePredictionQuery = (id: string | undefined) => ({
  queryKey: queryKeys.quoteRequestLineActivePrediction.detail(id),
  queryFn: () => fetchQuoteRequestLineActivePrediction(id),
  staleTime: STALE_TIME,
  enabled: !!id,
});
